import { render, staticRenderFns } from "./AbaCertificados.vue?vue&type=template&id=53264079"
import script from "./AbaCertificados.vue?vue&type=script&lang=js"
export * from "./AbaCertificados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports